module.exports = __webpack_public_path__ + "static/media/trashbin_white.0b4eef0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/trashbin_white.svg
// module id = 61
// module chunks = 0